import axios, { AxiosResponse } from "axios";
import ApplicationSettingDto from '../models/api/ApplicationSetting';


class Service {

    
    public async GetDatabaseVersion(): Promise<AxiosResponse<string>> {
        return axios.get(`api/setting/GetDatabaseVersion`);
    }

    public async GetAccessibilityStatementUrl(): Promise<AxiosResponse<string>> {
        return axios.get(`api/setting/GetAccessibilityStatementUrl`);
    }
    
    public async GetMunicipalityNameWithLoginPageText(): Promise<AxiosResponse<string>> {
        return axios.get(`api/setting/GetMunicipalityNameWithLoginPageText`);
    }

    public async GetMunicipalityLogo(): Promise<AxiosResponse<any>> {
        return axios.get('api/setting/GetMunicipalityLogo/');
    }

    public async GetSetting(keyName: string): Promise<AxiosResponse<ApplicationSettingDto>> {
        return axios.get(`api/setting/GetSettingByKeyName/?keyName=${keyName}`);
    }

    public async GetSettingsByKeyNames(settingKeyNames: string): Promise<AxiosResponse<[]>> {
        return axios.get(`api/setting/GetSettingsByKeyNames/?settingKeyNames=${settingKeyNames}`);
    }

    public async GetSettings(): Promise<AxiosResponse<[]>> {
        return axios.get('api/setting/');
    }

    public async SaveSetting(data: any): Promise<AxiosResponse<string>> {
        return axios.post('api/setting/', data);
    }

    public async SaveImage(image: FormData, keyName: string): Promise<AxiosResponse<any>> {
        return axios.post('api/setting/SaveImage/', image,
            {
                params: {
                    keyName: keyName
                }
            });
    }

    public async RemoveImage(keyName: string): Promise<AxiosResponse<[]>> {
        return axios.post(`api/setting/RemoveImage/?keyName=${keyName}`);
    }    

}

export const SettingService: Service = new Service();
